import { UiModalContent } from 'components';
import { utils } from 'lib';
import { useInterval } from 'lib/hooks';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useNumber } from 'react-hanger';
import styled from 'styled-components';
import map from 'lodash/map';
import Numbers from './numbers';

const Wrap = styled.div`
  position: relative;
  background: url(${require('./images/popup-bg-start.png')}) 0 0 / contain no-repeat;

  width: 374px;
  height: 420px;
  box-sizing: border-box;
  padding: 145px 80px 0;
  text-align: center;

  .title {
    font-size: 16px;
    font-weight: 600;
    line-height: 28px;
    text-align: center;
    height: 35px;
    color: #795b51;
  }

  .time {
    font-size: 12px;
    font-weight: normal;
    line-height: 12px;
    color: #e5c5a9;
    text-align: center;
  }

  .info {
    display: flex;
    justify-content: space-between;
    background: url(${require('./images/gift.png')}) center -16px / contain no-repeat;
    background-size: 120px 120px;
    font-size: 12px;
    height: 97px;
    &__item {
      position: relative;
      width: 80px;
      text-align: center;
      color: #795b51;
      padding-top: 10px;
      &--user:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        background: url(${require('./images/avatar-mask-blue.png')}) 0 0 / contain no-repeat;
        width: 80px;
        height: 80px;
      }
      &--star:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        background: url(${require('./images/avatar-mask-red.png')}) 0 0 / contain no-repeat;
        width: 80px;
        height: 80px;
      }

      img {
        width: 54px;
        height: 54px;
        border-radius: 50%;
        vertical-align: top;
      }
      .text-overflow {
        max-width: 5em;
        margin-top: 12px;
      }
    }
  }

  .timer {
    position: absolute;
    left: 50%;
    top: 250px;
    transform: translateX(-50%);
    white-space: nowrap;
    text-align: center;
  }

  .timer-name {
    color: #fff;
    padding-top: 62px;
    font-size: 12px;
  }

  .close {
    position: absolute;
    bottom: -35px;
    left: 50%;
    margin-left: -14px;
    background: url(${require('./images/close.png')}) 0 0 / contain no-repeat;

    width: 28px;
    height: 28px;
  }
`;

type IProps = {
  title: string;
  desc: string;
  data: {
    timestamp: number;
    second: number;
    userNickname: string;
    userPic: string;
    starNickname: string;
    starPic: string;
  };
  onClose: () => void;
};

const PopupEntry = observer((props: IProps) => {
  const {
    title,
    desc,
    data: { timestamp, second, userNickname, userPic, starNickname, starPic },
    onClose,
  } = props;

  const timer = useNumber(second);

  useInterval(
    () => {
      timer.decrease();
    },
    timer.value > 0 ? 1000 : null,
  );

  useEffect(() => {
    if (timer.value === 0) {
      onClose();
    }
  }, [timer.value]);

  return (
    <UiModalContent maskEnable={false}>
      <Wrap>
        <div className="title">{title}</div>
        <div className="info">
          <div className="info__item info__item--user">
            <div>
              <img src={userPic} alt="" />
            </div>
            <div className="text-overflow">{userNickname}</div>
          </div>
          <div className="info__item  info__item--star">
            <div>
              <img src={starPic} alt="" />
            </div>
            <div className="text-overflow">{starNickname}</div>
          </div>
        </div>
        <div className="timer">
          {map(`${timer.value}`, (num, index) => {
            return <Numbers num={num} key={`${index}_${num}`}></Numbers>;
          })}
        </div>
        <div className="timer-name">{desc}</div>

        <button className="close" onClick={onClose}></button>
      </Wrap>
    </UiModalContent>
  );
});

export default PopupEntry;
